const managerRoutes = [
    "/dashboard",
    "/company_employees",
    "/add_employee",
    "/company_locations",
    "/add_location",
    "/location_details",
    "/edit_company",
    "/company_courses",
    "/create_course",
    "/company_coursefolders",
    "/course_instructions",
    "/company_certificates",
    "/certificate_details",
    "/employee_certificates",
    "/employee_resources",
    "/employee_documents",
    "/login_report",
    "/activity_report",
    "/course_fail_pass_report",
    "/documents-report",
    "/scorm-report",
    "/scorm-report/details/employee/:employee_id/course/:course_id",
    "/tutorial_video",
    "/account",
    "/lesson_form",
    "/employee_courses",
    "/account",
    "/add_employee",
    "/company_course_details"
  ];
  const employeeRoutes =[
    "/dashboard",
    "/employee_courses",
    "/employee_certificates",
    "/employee_resources",
    "/employee_documents",
    "/tutorial_video",
    "/add_employee",
    "/course_instructions",
    "/lesson_form",
  ];
  const companyAdminRoutes = [
    "/dashboard",
    "/company_employees",
    "/add_employee",
    "/company_locations",
    "/add_location",
    "/location_details",
    "/edit_company",
    "/company_courses",
    "/employee_courses",
    "/course_instructions",
    "/company_coursefolders",
    "/company_certificates",
    "/certificate_details",
    "/employee_certificates",
    "/employee_resources",
    "/employee_documents",
    "/login_report",
    "/activity_report",
    "/course_fail_pass_report",
    "/documents-report",
    "/scorm-report",
    "/scorm-report/details/employee/:employee_id/course/:course_id",
    "/tutorial_video",
    "/account",
    "/create_course",
    "/lesson_form",
    "/company_course_details"
  ]
const roleAccessMap = {
  "company-admin": companyAdminRoutes,
  "manager": managerRoutes,
  "general-manager": managerRoutes,
  "manager_d_r": managerRoutes,
  "employee": employeeRoutes,
  "FTM": managerRoutes,
};

export const publicRoutes = [
  '/login',
  '/register',
  '/register_1-3_locations',
  '/user_register',
  '/signup',
  '/home',
  '/forget_password',
  '/reset_password',
  '/tour',
  '/mra-login',
  '/mra-signup',
  '/mra-register',
  '/mra-corporate-register',
  '/nvra-login',
  '/nvra-signup',
  '/nvra-register',
  '/nvra-corporate-register',
  '/orla-login',
  '/orla-signup',
  '/orla-register',
  '/orla-corporate-register',
  '/not_authorized',
  '/NotFound',
  '/account',
];

export const protectedRoutes = [
  '/dashboard',
  '/all_companies',
  '/edit_company',
  '/certificates',
  '/courses',
  '/create_course',
  '/course_folder',
  '/course_folder_details',
  '/create_course_folder',
  '/certificate_details',
  '/create_company',
  '/test_question_report',
  '/survey_report',
  '/survey_submissions',
  '/survey_submissions_detail',
  
  '/tutorial_video',
  '/add_tutorial_video',
  '/tour_page',
  '/add_tour_video',
  '/create_certificate',
  '/all_users',
  '/create_user',
  '/company_locations',
  '/add_location',
  '/company_certificates',
  '/company_courses',
  '/location_details',
  '/company_coursefolders',
  '/course_catalog',
  '/company_course_details',
  '/course_instructions',
  '/lesson_form',
  '/edit_course',
  '/employee_certificates',
  '/employee_resources',
  '/employee_documents',
  '/employee_courses',
  '/employee_course_purchase',
  '/add_employee',
  '/company_employees',
  '/resources',
  '/login_report',
  '/activity_report',
  '/documents-report',
  '/course_fail_pass_report',
  '/onboarding_report',
  '/all_onboarding_report',
  '/hrform_report',
  '/create_subadmin',
  '/promo_codes',
  '/create_promo_code',
  '/promo_code_report',
];


export default roleAccessMap;

